<template>
  <div v-if="description" class="scene-desc-wrapper">
    <button @click="expanded = !expanded" class="desc-icon-btn" :class="{ active: expanded }" title="Scene info">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
      </svg>
    </button>
    <!-- Info panel -->
    <div v-if="expanded" class="desc-panel">
      <div class="desc-panel-header">
        <span>Info</span>
        <button @click="expanded = false" class="desc-close">×</button>
      </div>
      <div class="desc-panel-body">
        <p>{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  description: string | null | undefined
}>()

const expanded = ref(false)
</script>

<style scoped>
.scene-desc-wrapper {
  position: absolute;
  top: 110px;
  left: 16px;
  z-index: 15;
}

.desc-icon-btn {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
  transition: all 0.2s;
}

.desc-icon-btn:hover,
.desc-icon-btn.active {
  background: rgba(0, 0, 0, 0.8);
  border-color: rgba(59, 130, 246, 0.5);
}

.desc-panel {
  position: absolute;
  top: 0;
  left: 48px;
  min-width: 240px;
  max-width: 360px;
  background: rgba(15, 23, 42, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 10px;
  backdrop-filter: blur(12px);
  animation: fadeIn 0.15s ease;
}

.desc-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.desc-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

.desc-close:hover {
  color: white;
}

.desc-panel-body {
  padding: 10px 12px;
}

.desc-panel-body p {
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  line-height: 1.5;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateX(-4px); }
  to { opacity: 1; transform: translateX(0); }
}

@media (max-width: 768px) {
  .scene-desc-wrapper {
    top: 100px;
    left: 12px;
  }

  .desc-icon-btn {
    width: 34px;
    height: 34px;
  }

  .desc-panel {
    left: 42px;
    min-width: 200px;
    max-width: calc(100vw - 80px);
  }
}
</style>
